<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import Header from '@/components/MainInterface/Header.vue'
import MainContent from '@/components/MainInterface/MainContent.vue'
import MainFooter from '@/components/MainInterface/MainFooter.vue'
import ModalList from '@/components/Interface/Modal/ModalList.vue'
import LoadingIndicator from '@/components/Interface/Network/LoadingIndicator.vue'
import ToastList from '@/components/Interface/Toast/ToastList.vue'
import SoftLoading from '@/components/Interface/Network/SoftLoading.vue'
import TinyToast from '@/components/Interface/Toast/TinyToast.vue'
import ModalTutorial from '@/components/Interface/Modal/Modals/Tutorial/ModalTutorial.vue'
</script>

<template>
  <LoadingIndicator></LoadingIndicator>
  <SoftLoading></SoftLoading>
  <div class="mx-auto game-container">
    <Header></Header>
    <MainContent></MainContent>
    <MainFooter></MainFooter>
    <ModalList></ModalList>
    <ModalTutorial></ModalTutorial>
    <ToastList></ToastList>
    <TinyToast></TinyToast>
  </div>
  <!--    </div>-->
  <!--  </div>-->
</template>

<style>
html,
body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.game-container {
  max-width: 100vw;
  overflow-x: hidden;
}

/* TODO: move this */
.content-height-limit {
  overflow-y: auto;
  overflow-x: hidden;

  height: calc(100vh - 5.5rem - var(--chat-height));
}

.content-height-limit-map {
  overflow-y: auto;
  overflow-x: hidden;

  height: calc(100vh - 5rem - var(--chat-height));
}

.content-height-limit-tab {
  height: calc(100vh - 8.5rem - var(--chat-height));
}

.content-height-limit-small-modal {
  overflow-y: auto;
  overflow-x: auto;
  max-height: calc(100vh - 6rem - var(--chat-height) - 20rem);
}

.content-height-limit-fleet-details {
  height: calc(100vh - 5.8rem - var(--chat-height) - 20rem);
}

.content-height-limit-ship-details {
  overflow-y: auto;
  height: calc(100vh - 10rem - var(--chat-height) - 20rem);
}

@media (max-width: 768px) {
  .content-height-limit {
    height: auto;
    min-height: 300px;
    max-height: calc(100vh - 5.5rem - var(--chat-height));
    overflow-y: auto;
  }
}

/* Solution for mobile keyboard issues */
@media screen and (max-height: 450px) {
  /* When keyboard is open, height typically drops below 450px */
  .content-height-limit {
    height: auto;
    min-height: 200px;
  }
}

.game-container {
  overflow-x: hidden;
}

/* Targets the scrollbar of all elements including the viewport */
*::-webkit-scrollbar {
  width: 6px; /* Thinner width for vertical scrollbars */
  height: 6px; /* Thinner height for horizontal scrollbars */
}

*::-webkit-scrollbar-track {
  background: #1e293b; /* Light grey background for the track */
}

*::-webkit-scrollbar-thumb {
  background-color: #475569; /* Darker grey for the thumb */
  border-radius: 4px; /* Rounded corners for the thumb */
  border: 1px solid #1e293b; /* Optional: Adds a border matching the track */
}

/* Add hover effect for the scrollbar thumb */
*::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}

.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.no-scrollbar::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}

@media (min-width: 992px) {
  .model-width-lg {
    width: 1920px;
    max-width: 100%;
    margin: 0 auto;
  }
}
</style>
